import { FC } from 'react';

import { SlideOut } from '@hsp/react-component-library';
import { isDefined } from '@hsp/utilities';

import { useReset } from '@p/audience/shared';
import ProfileInfo from '@p/security/users/dashboard/component/slideout/user-profile/slideout-body/body.component';
import { userStore } from '@p/security/users/store/store';

import { IUserInfo } from '@t/user/components/user-info/user-profile.model';

const UserSlideoutInfo: FC<IUserInfo> = ({ item }) => {
  const { setIsOpenUserInfo } = userStore();
  const reset = useReset();

  const isOpenUserInfo = userStore(({ isOpenUserInfo: open }) => {
    if (typeof open === 'string') {
      if (isDefined(item)) {
        return open === item.userId;
      }

      return false;
    }

    return open;
  });

  return (
    <>
      <SlideOut
        icon={['fas', 'user']}
        isOpen={isOpenUserInfo}
        onClosed={() => {
          setIsOpenUserInfo(false);
          reset();
        }}
        title="User Profile">
        {<ProfileInfo item={item} />}
      </SlideOut>
    </>
  );
};

export default UserSlideoutInfo;
